import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useNavigate } from "react-router";

/** Props Interface */
interface ProtocolsMenuProps {
	createQueryString?: string;
}

export function ProtocolsMenu({ createQueryString }: ProtocolsMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const navigate = useNavigate();

	/** Functions */
	function handleOnNavigateToCreate() {
		if (createQueryString) {
			navigate(`/protocols/create${createQueryString}`);
		} else {
			navigate("/protocols/create");
		}
	}

	/** Render */
	return (
		<Button
			variant="primary"
			icon={<Icon name="Plus" />}
			onClick={handleOnNavigateToCreate}
			data-cy="create-protocol-button"
		>
			{t("protocols.create_protocol")}
		</Button>
	);
}
